import { apiClient } from './api';
import type { 
  TrainingProgram, 
  CreateTrainingProgramInput, 
  UpdateTrainingProgramInput, 
  ApiCollection 
} from './types';

export class TrainingProgramService {
  private static readonly ENDPOINT = '/api/training_programs';

  static async getAll(): Promise<TrainingProgram[]> {
    const response = await apiClient.get<ApiCollection<TrainingProgram>>(this.ENDPOINT);
    return response.data['member'];
  }

  static async getById(id: number): Promise<TrainingProgram> {
    const response = await apiClient.get<TrainingProgram>(`${this.ENDPOINT}/${id}`);
    return response.data;
  }

  static async create(program: CreateTrainingProgramInput): Promise<TrainingProgram> {
    const response = await apiClient.post<TrainingProgram>(this.ENDPOINT, program);
    return response.data;
  }

  static async update(id: number, program: Partial<CreateTrainingProgramInput>): Promise<TrainingProgram> {
    const response = await apiClient.patch<TrainingProgram>(`${this.ENDPOINT}/${id}`, program);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.ENDPOINT}/${id}`);
  }

  // Utility methods
  static async getActivePrograms(): Promise<TrainingProgram[]> {
    const programs = await this.getAll();
    return programs.filter(program => program.active);
  }

  static async getByGoal(goal: string): Promise<TrainingProgram[]> {
    const programs = await this.getAll();
    return programs.filter(program => program.goal === goal);
  }

  static async getByDifficulty(difficulty: string): Promise<TrainingProgram[]> {
    const programs = await this.getAll();
    return programs.filter(program => program.difficulty === difficulty);
  }

  static async setActive(id: number, active: boolean): Promise<TrainingProgram> {
    return this.update(id, { active });
  }
}

export default TrainingProgramService;